import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { baseURL } from "../../constants/pathnames";
import RadioButton from "../RadioButton/RadioButton";
import Table from "../Table/Table";
import moment from "jalali-moment";

const UserPlans = ({ userid }) => {
  const { token } = useSelector((state) => state.users);
  const header = useMemo(() => {
    const headers = {
      headers: {
        Authorization: `jwt ${token}`,
      },
    };
    return headers;
  }, [token]);

  const [filter, setFilter] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [data, setData] = useState([]);
  const [next, setNext] = useState("");
  const [rows, setRows] = useState([]);
  const columns = [
    { Header: "عنوان", accessor: "title" },
    { Header: "امتیاز مورد نیاز", accessor: "score" },
    { Header: "تاریخ", accessor: "date" },
    { Header: "وضعیت", accessor: "status" },
  ];

  const getData = useCallback(() => {
    debugger;
    axios
      .get(
        `${baseURL}product/panel/user/plan/${userid}/${
          filter === 0 ? "?is_used=false" : filter === 1 ? "?is_used=true" : ""
        }`,
        header
      )
      .then((res) => {
        console.log(res.data);
        setData(res.data.results);
        setNext(res.data.next);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [userid, header, filter]);
  useEffect(() => {
    getData();
  }, [getData]);
  const getNextList = () => {
    debugger;
    if (next != null) {
      axios
        .get(next, header)
        .then((res) => {
          console.log("res", res.data);
          setData([...data, ...res.data.results]);
          setNext(res.data.next);
        })
        .catch((err) => {
          console.log("err", err.response);
        });
    }
  };

  useEffect(() => {
    debugger;
    const newArray = [];
    for (let i = 0; i < data?.length; i++) {
      const tr = data[i];
      newArray.push({
        title: tr?.title,
        score: tr?.score,
        date: moment(tr?.created_time).locale("fa").format("YYYY/MM/DD"),
        status:
          tr?.is_used === true ? (
            <div className='color-green2'>فعال</div>
          ) : tr?.is_used === false ? (
            <div className='color-red'>غیرفعال</div>
          ) : (
            ""
          ),
      });
    }
    setRows(newArray);
  }, [data]);
  const filtersRadioButtonData = [
    { value: 0, label: "فقط غیرفعال" },
    { value: 1, label: "فقط فعال" },
  ];
  return (
    <>
      <div className='my-10 shadow rounded-xl overflow-x-hidden mx-1 p-1'>
        <div className='flex justify-between items-center mx-3 py-5'>
          <div className='text-xl font-semibold mr-5'>پلن های خریداری شده</div>

          {/* filter */}
          <div className='relative m-1 py-2 px-2 rounded-lg shadow cursor-pointer h-8 w-8 flex justify-center items-center'>
            <img
              className=''
              src='/statics/images/filter.svg'
              width='16'
              alt='filter'
              onClick={() => setShowFilter(!showFilter)}
            />
            {showFilter && (
              <div
                className='absolute top-10 left-0 min-w-max'
                style={{
                  zIndex: "100000",
                }}
              >
                <div className='rounded-lg shadow p-3 bg-white min-w-max'>
                  <RadioButton
                    data={filtersRadioButtonData}
                    change={(value) => {
                      setFilter(value);
                    }}
                    column
                    fontSize='12px'
                    checkedValue={filter}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <InfiniteScroll
          className='w-100'
          dataLength={data?.length}
          next={() => getNextList()}
          hasMore={true}
          loader={
            next ? (
              <div className='mx-auto w-max color-blue'>در حال جستجو...</div>
            ) : (
              ""
            )
          }
          scrollableTarget='scrollableDiv'
        >
          <div
            className='overflow-y-scroll scroll-style px-2 ltr h-full '
            style={{ maxHeight: "70vh" }}
          >
            <div className='rtl m-5 md:m-0'>
              <Table
                classs='paneltable UsersTable'
                columns={columns}
                data={rows}
                hasSpace
              />
            </div>
          </div>
        </InfiniteScroll>
      </div>
    </>
  );
};

export default UserPlans;
